/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Users module

define('modules/User/Users.Forms',[], function () {
    'use strict';

    // Forms definitions
    var forms = {
        'Login': {
            Fields: [
                { 'Name': 'Email', 'Field': '#login_email', 'Param': 'username', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] },
                { 'Name': 'Password', 'Field': '#login_password', 'Param': 'password', 'Type': 'Text' },
                { 'Name': 'KeepLoggednIn', 'Field': '#login_keep', 'Param': 'keepLoggedIn', 'Type': 'Checkbox', 'Optional': true }
            ],
            Validate: true
        },
        'Email': {
            Fields: [
                { 'Name': 'Email', 'Field': '#register_email', 'Param': 'email', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] },
                {
                    'Name': 'Confirm Email', 'Field': '#register_email2', 'Param': 'emailConfirm', 'Type': 'Text',
                    'Validators':
                        [
                            { 'Type': 'Email' },
                            {
                                'Type': 'ConfirmField',
                                'OriginField': '#register_email',
                                'ErrorMsg': 'Email does not match the confirm email.'
                            }]
                }
            ],
            Validate: true
        },
        'Registration': {
            Fields: [
                {
                    'Name': 'First Name',
                    'Field': '#register_first_name',
                    'Param': 'firstName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Last Name',
                    'Field': '#register_last_name',
                    'Param': 'lastName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Email',
                    'Field': '#register_email',
                    'Param': 'email',
                    'Type': 'Text',
                    'Validators': [{
                        'Type': 'Email'
                    }]
                },
                {
                    'Name': 'Confirm Email',
                    'Field': '#register_email2',
                    'Param': 'emailConfirm',
                    'Type': 'Text',
                    'Validators':
                        [
                            { 'Type': 'Email' },
                            {
                                'Type': 'ConfirmField',
                                'OriginField': '#register_email',
                                'ErrorMsg': 'Email does not match the confirm email.'
                            }]
                },
                {
                    'Name': 'Password',
                    'Field': '#register_password',
                    'Param': 'password',
                    'Type': 'Text'
                },
                {
                    'Name': 'Confirm Password',
                    'Field': '#register_password2',
                    'Param': 'passwordConfirm',
                    'Type': 'Text',
                    'Validators':
                        [
                            {
                                'Type': 'ConfirmField',
                                'OriginField': '#register_password',
                                'ErrorMsg': 'Password does not match the confirm password.'
                            }]
                },
                {
                    'Name': 'Organization name',
                    'Field': '#register_organization',
                    'Param': 'organizationName',
                    'Type': 'Text',
                    'Optional': true,
                    'Validators':
                        [
                            {
                                'Type': 'RequiredIfField',
                                'ConditionalField': '#requestBusinessAccount',
                                'ConditionalValue': true,
                                'ConditionalFieldType': 'Checkbox'
                            }]
                },
                {
                    'Name': 'emailSignUp',
                    'Field': '#requestEmailSignUp',
                    'Param': 'emailSignUp',
                    'Type': 'Checkbox',
                    'Optional': true
                },
            ],
            Validate: true
        },
        'ForgotPassword': {
            Fields: [
                { 'Name': 'Email', 'Field': '#forgot_email', 'Param': 'email', 'Type': 'Text', 'Validators': [{ 'Type': 'Email' }] }
            ],
            Validate: true
        },
        'ChangePassword': {
            Fields: [
                { 'Name': 'User id', 'Field': '#forgot_user_id', 'Param': 'userId', 'Type': 'Hidden' },
                { 'Name': 'Password', 'Field': '#forgot_password', 'Param': 'newPassword', 'Type': 'Text' },
                { 'Name': 'Confirm Password', 'Field': '#forgot_password2', 'Type': 'Text' }
            ],
            Validate: true
        },
        'EditAccount': {
            Fields: [
                { 'Name': 'Password', 'Field': '#current-password', 'Param': 'currentPassword', 'Type': 'Text' },
                { 'Name': 'New Password', 'Field': '#new-password', 'Param': 'newPassword', 'Type': 'Text' },
                { 'Name': 'Retype New Password', 'Field': '#new-password-confirm', 'Type': 'Text' }
            ],
            Validate: true
        },
        'EditProfile': {
            Fields: [
                { 'Name': 'First Name', 'Field': '#first-name', 'Param': 'firstName', 'Type': 'Text' },
                { 'Name': 'Last Name', 'Field': '#last-name', 'Param': 'lastName', 'Type': 'Text' }
            ],
            Validate: true
        },
        'PackardRegistration': {
            Fields: [
                // Personal & Company Information
                {
                    'Name': 'Account Number',
                    'Field': '#register_account_number',
                    'Param': 'accountNumber',
                    'Type': 'Text',
                    'Optional': true
                },
                {
                    'Name': 'First Name',
                    'Field': '#register_first_name',
                    'Param': 'firstName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Last Name',
                    'Field': '#register_last_name',
                    'Param': 'lastName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Job Title/Department',
                    'Field': '#register_job_title',
                    'Param': 'jobTitle',
                    'Type': 'Select'
                },
                {
                    'Name': 'Full Company Name',
                    'Field': '#register_company_name',
                    'Param': 'fullCompanyName',
                    'Type': 'Text'
                },
                {
                    'Name': 'Business Type',
                    'Field': '#register_business_type',
                    'Param': 'businessType',
                    'Type': 'Select'
                },
                // Address Information
                {
                    'Name': 'Country',
                    'Field': '#register_country',
                    'Param': 'country',
                    'Type': 'Select'
                },
                {
                    'Name': 'Company Address 1',
                    'Field': '#register_address1',
                    'Param': 'address1',
                    'Type': 'Text'
                },
                {
                    'Name': 'Company Address 2',
                    'Field': '#register_address2',
                    'Param': 'address2',
                    'Type': 'Text',
                    'Optional': true
                },
                {
                    'Name': 'City',
                    'Field': '#register_city',
                    'Param': 'city',
                    'Type': 'Text'
                },
                {
                    'Name': 'State',
                    'Field': '#register_state',
                    'Param': 'state',
                    'Type': 'Select',
                    'Optional': true
                },
                {
                    "Name": 'Region',
                    "Field": '#register_region',
                    "Param": 'region',
                    "Type": 'Text',
                    "Optional": true
                },
                    {
                        'Name': 'Zip',
                        'Field': '#register_zip',
                        'Param': 'zip',
                        'Type': 'Text',
                        "Validators": [
                            {
                                "Type": 'Zip',
                                "ReferencedField": '#register_country'
                            }
                        ]
                    },
                {
                    'Name': 'Company Phone',
                    'Field': '#register_company_phone',
                    'Param': 'phone',
                    'Type': 'Text',
                    "Validators": [
                        {
                            "Type": 'Phone'
                        }
                    ]
                },
                {
                    'Name': 'Company Fax',
                    'Field': '#register_company_fax',
                    'Param': 'fax',
                    'Type': 'Text',
                    'Optional': true,
                    "Validators": [
                        {
                            "Type": 'Phone'
                        }
                    ]
                },
                {
                    'Name': 'Save as default shipping',
                    'Field': '#register_save_as_default_shipping',
                    'Param': 'saveAsDefaultShipping',
                    'Type': 'Checkbox',
                    'Optional': true
                },
                // Create your Login
                {

                    'Name': 'E-mail Address',
                    'Field': '#register_email',
                    'Param': 'email',
                    'Type': 'Text',
                    'Validators': [{
                        'Type': 'Email'
                    }]
                },
                {
                    'Name': 'Confirm Email',
                    'Field': '#register_email2',
                    'Param': 'emailConfirm',
                    'Type': 'Text',
                    'Validators':
                    [
                        { 'Type': 'Email' },
                        {
                            'Type': 'ConfirmField',
                            'OriginField': '#register_email',
                            'ErrorMsg': 'Email does not match the confirm email.'
                        }]
                },
                {

                    'Name': 'Password',
                    'Field': '#register_password',
                    'Param': 'password',
                    'Type': 'Text'
                },
                {
                    'Name': 'Confirm Password',
                    'Field': '#register_password2',
                    'Param': 'passwordConfirm',
                    'Type': 'Text',
                    'Validators':
                    [
                        {
                            'Type': 'ConfirmField',
                            'OriginField': '#register_password',
                            'ErrorMsg': 'Password does not match the confirm password.'
                        }]
                }
            ],
            Validate: true
        }
    };

    return forms;
});
